/*
Copyright 2022-2024 New Vector Ltd.
Copyright 2026 QonGroup GmbH.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import { type MatrixClient } from "matrix-js-sdk";
import { useTranslation } from "react-i18next";
import { Heading, Text } from "@vector-im/compound-web";

import styles from "./CallEndedView.module.css";
import { useProfile } from "../profile/useProfile";

interface Props {
  client: MatrixClient;
  isPasswordlessUser: boolean;
  hideHeader: boolean;
  confineToRoom: boolean;
  endedCallId: string;
}

export const CallEndedView: FC<Props> = ({ client }) => {
  const { t } = useTranslation();
  const { displayName } = useProfile(client);

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <Heading size="xl" weight="semibold" className={styles.headline}>
          {t("call_ended_view.headline", { displayName })}
        </Heading>
        <Text>Du kannst dieses Fenster jetzt schließen.</Text>
      </main>
    </div>
  );
};
